<template>
  <transition name="fade">
    <div class="ctpx-modal" v-if="show">
      <div class="ctpx-modal-background" @click="closeModal()" />

      <div class="ctpx-modal-dialog">
        <button type="button" class="ctpx-modal-close" @click="closeModal()">
          <span></span>
        </button>
        <div class="ctpx-modal-header" v-if="$slots.header">
          <slot name="header" />
        </div>

        <div class="ctpx-modal-body">
          <slot name="body" />
        </div>

        <div class="ctpx-modal-footer" v-if="$slots.footer">
          <slot name="footer" />
        </div>
      </div>
    </div>
  </transition>
</template>

<script src="./ctrl-modal.js"></script>
